import { lazyLoad } from '~/src/shared/utils/loadable';

export const ParticipantWorkingTimeWorkingPage = lazyLoad(
  () => import('./index'),
  (module) => module.ParticipantWorkingTimeWorking,
);
